import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Mail, ArrowRight, Loader2 } from 'lucide-react';
export function PortalRequestOtp({ tenantSlug, onEmailSubmitted }) {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const buildApiUrl = (path) => {
        const envBase = (import.meta.env.VITE_API_URL ?? '/').trim();
        const invalidHostOnly = /^https?:\/\/[a-z0-9-]+$/i.test(envBase);
        const normalizedBase = !envBase || invalidHostOnly
            ? '/'
            : envBase.endsWith('/')
                ? envBase
                : `${envBase}/`;
        return `${normalizedBase}${path.replace(/^\//, '')}`;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const res = await fetch(buildApiUrl('/api/v1/portal/request-otp'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ tenantSlug, email }),
            });
            if (!res.ok) {
                const data = await res.json();
                throw new Error(data.message ?? 'Error al enviar código');
            }
            setSuccess(true);
            setTimeout(() => onEmailSubmitted(email), 2000);
        }
        catch (err) {
            setError(err.message);
        }
        finally {
            setLoading(false);
        }
    };
    if (success) {
        return (_jsxs("div", { className: "text-center py-12 animate-fade-in", children: [_jsx("div", { className: "w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4", children: _jsx(Mail, { className: "w-8 h-8 text-green-600" }) }), _jsx("h2", { className: "text-2xl font-bold text-gray-900 mb-2", children: "Revisa tu correo" }), _jsxs("p", { className: "text-gray-600", children: ["Te hemos enviado un c\u00F3digo de 6 d\u00EDgitos a ", _jsx("strong", { children: email })] }), _jsx("p", { className: "text-sm text-gray-400 mt-2", children: "V\u00E1lido por 15 minutos" })] }));
    }
    return (_jsxs("div", { className: "animate-fade-in", children: [_jsxs("div", { className: "text-center mb-8", children: [_jsx("h2", { className: "text-2xl font-bold text-gray-900 mb-2", children: "Accede a tu portal" }), _jsx("p", { className: "text-gray-600", children: "Ingresa tu correo electr\u00F3nico para recibir un c\u00F3digo de acceso" })] }), _jsxs("form", { onSubmit: handleSubmit, className: "space-y-4", children: [_jsxs("div", { children: [_jsx("label", { htmlFor: "email", className: "block text-sm font-medium text-gray-700 mb-1", children: "Correo electr\u00F3nico" }), _jsx("input", { id: "email", type: "email", required: true, value: email, onChange: e => setEmail(e.target.value), placeholder: "tu@email.com", className: "w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all text-gray-900 placeholder-gray-400" })] }), error && (_jsx("div", { className: "bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm", children: error })), _jsxs("button", { type: "submit", disabled: loading, className: "w-full flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-300 text-white font-semibold rounded-xl transition-all", children: [loading ? _jsx(Loader2, { className: "w-5 h-5 animate-spin" }) : _jsx(ArrowRight, { className: "w-5 h-5" }), loading ? 'Enviando...' : 'Recibir código'] })] })] }));
}
//# sourceMappingURL=PortalRequestOtp.js.map